var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AddFormItem',{attrs:{"bp":_vm.bp,"fields":_vm.fields,"custom_icon":_vm.custom_icon,"hide_button":_vm.hide_button,"button_text":_vm.icon ? null : 'New Data Inline'},on:{"submit":_vm.submit_action}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }